module.exports = __webpack_public_path__ + "img/melvid-dashboard1.b25d0565.png";